import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import { Card } from "@material-ui/core";
import MDTypography from "components/MDTypography";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useParams, useNavigate } from 'react-router-dom';
import configurations from "config";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { FormControl, Backdrop, Tooltip, TooltipProps, tooltipClasses } from '@mui/material';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArchiveIcon from '@mui/icons-material/Archive';
import Box from '@mui/material/Box';
import DataTable from "layouts/Tables/DataTable";
import noImage from "assets/images/no-image.png";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout/index.js";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar/index.js";
import Footer from "examples/Footer";
import CircularProgress from "@mui/material/CircularProgress";
import { PRODUCT } from "constants";
import { handleErrors } from "common";
import { useMaterialUIController } from "context";
import { setProductContext } from "context";
import DeleteConfirmation from "layouts/components/DeleteConfirmation";
import ReadMoreIcon from '@mui/icons-material/ReadMore';
import { styled } from '@mui/material/styles';

function Manage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const baseUrl = configurations.baseUrl;
  const azureFunctionVendorFrontendKey = configurations.azureFunctionVendorFrontendKey;
  const bearerToken = `Bearer ${localStorage.getItem('JWTToken')}`;
  const [productData, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { pageNo } = useParams();
  var pageSelected = 1;
  const [responseResultCount, setResponseResultCount] = useState(0);
  const [controller, dispatch, initialState] = useMaterialUIController();
  const { productContext, MyContext } = controller;
  const [isProductContextChanged, setProductContextChanged] = useState(false);
  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(0);

  if (typeof pageNo !== "undefined") {
    const parts = pageNo.split("-");
    pageSelected = parts[1].trim();
  }

  const data = () => {
    setIsLoading(true)
    axios.get(baseUrl + "/product/manageProduct?pageSelected=" + pageSelected + "&statusFilter=" + productContext.statusFilter + "&orderBy=" + productContext.orderBy + "&orderValue=" + productContext.orderValue + "&searchBy=" + productContext.searchBy + "&searchValue=" + productContext.searchValue + "&dataFrom=products", {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey },
    })
      .then(function (response) {
        setIsLoading(false);
        const message = response.data.message;
        response.status == 200 ?
          (
            response.data.status == 1 ?
              (setData(response.data),
                (response.data && response.data.data && response.data.data.totalCount) ?
                  setResponseResultCount(response.data.data.totalCount)
                  :
                  null)
              :
              toast.error(t(message))
          )
          :
          toast.error(t('unableToProccessRequest'));
      })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data();
  }, [pageNo]);

  const handleResetFilters = () => {
    setProductContext(dispatch, initialState.productContext);
    setProductContextChanged(false);
    if (typeof pageNo === "undefined")
      navigate("/products/manage/page-1");
    else
      navigate("/products/manage");
  };

  useEffect(() => {
    const hasChanged = Object.keys(productContext).some(
      key => productContext[key] !== initialState.productContext[key]
    );
    setProductContextChanged(hasChanged);
  }, [productContext]);

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      minWidth: "500px",
      maxHeight: 300,
      overflowY: 'auto',
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

  const columns = [
    { Header: t('image'), accessor: "image", align: "left" },
    { Header: t('productId'), accessor: "id", align: "left" },
    { Header: t('title'), accessor: "title", align: "left" },
    { Header: t('GSTSlab'), accessor: "gstSlab", align: "left" },
    { Header: t('status'), accessor: "status", align: "center" },
    { Header: t('action'), accessor: "action", align: "center" }
  ];

  const handleProductDelete = (id) => {
    let requestData = { productId: id };
    setIsLoading(true);
    axios.post(baseUrl + '/product/deleteProduct', requestData, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
    }).then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message))
          if (productData.data.rows) {
            const tempNewRows = productData.data.rows;
            for (const key2 in tempNewRows) {
              if (tempNewRows[key2]['id'] == id) {
                setData(prevState => {
                  const updatedProductStatus = prevState.data.rows.map(item => {
                    if (item.id === id) {
                      return { ...item, status: PRODUCT.DELETED };
                    }
                    return item;
                  })
                  return {
                    ...prevState,
                    data: {
                      ...prevState.data,
                      rows: updatedProductStatus
                    }
                  };
                });
              }
            }
          }
        }
        else {
          if (message != '')
            toast.error(t(message))
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(error => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }

  const handleChangeProductStatus = (id) => {
    let requestData = { productId: id };
    setIsLoading(true);
    axios.post(baseUrl + '/product/changeProductStatus', requestData, {
      headers: { Authorization: bearerToken, function: azureFunctionVendorFrontendKey }
    }).then((response) => {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message))
          if (productData.data.rows) {
            const tempNewRows = productData.data.rows;
            for (const key2 in tempNewRows) {
              if (tempNewRows[key2]['id'] == id) {
                setData(prevState => {
                  const updatedProductStatus = prevState.data.rows.map(item => {
                    if (item.id === id) {
                      return { ...item, status: PRODUCT.ARCHIVED };
                    }
                    return item;
                  })
                  return {
                    ...prevState,
                    data: {
                      ...prevState.data,
                      rows: updatedProductStatus
                    }
                  };
                });
              }
            }
          }
        }
        else {
          if (message != '')
            toast.error(t(message))
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(error => {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  }
  const finalObj = [];
  for (const key in productData.data) {
    if (productData.data.hasOwnProperty(key)) {
      let dataObj = productData.data[key];
      for (const key1 in dataObj) {
        let dataRow = dataObj[key1];
        if (dataRow.id > 0) {
          let tempObj = {
            image: <MDBox
              component="img"
              src={dataRow.image ? dataRow.image : noImage}
              className="profileThumbImage"
            />,
            id: '#' + dataRow.id,
            title: ((dataRow.title).length <= 50) ? dataRow.title : <HtmlTooltip title={dataRow.title}>
              <MDTypography component="span" className="tooltipMessage" variant="body3" color="text"> {(dataRow.title).substring(0, 50)}<ReadMoreIcon className="readMoreIcon" /></MDTypography>
            </HtmlTooltip>,
            gstSlab:dataRow.gstSlab,
            vendorShopName: dataRow.vendorShopName, status: <span className={'statusD' + dataRow.status}> {(dataRow.status == PRODUCT.DRAFT) ? t('draft') : (dataRow.status == PRODUCT.ACTIVE) ? t('active') : (dataRow.status == PRODUCT.PENDING) ? t('pending') : (dataRow.status == PRODUCT.REJECTED) ? t('rejected') : (dataRow.status == PRODUCT.ARCHIVED) ? t('archived') : (dataRow.status == PRODUCT.DELETED) ? t('deleted') : null}</span>,
            action: <span className="actionClass">
              {((dataRow.status != PRODUCT.ARCHIVED) && (dataRow.status != PRODUCT.DELETED)) ?
                <MDTypography component="a" href="#" onClick={(event) => { event.preventDefault(); navigate("/products/editProduct/" + dataRow.id) }} variant="caption" color="text" fontWeight="medium">
                  <Tooltip title={t('edit')} className="paddingRight5"><Box className="ActionEdit"><EditIcon /></Box></Tooltip>
                </MDTypography>
                : null
              }
              {dataRow.shopifyProductId ?
                (dataRow.status == PRODUCT.ACTIVE) ?
                  <MDTypography component="a" href={"#"} onClick={() => handleChangeProductStatus(dataRow.id)}>
                    <Tooltip title={t('archive')}><Box className="ActionArchieve paddingRight5"><ArchiveIcon /></Box></Tooltip>
                  </MDTypography>
                  : null
                :
                (dataRow.status == PRODUCT.ACTIVE || dataRow.status == PRODUCT.DELETED) ?
                  null :
                  <MDTypography component="a" href="#"
                    onClick={(event) => {
                      event.preventDefault();
                      setConfirmationDialogOpen(true);
                      setDeleteId(dataRow.id);
                    }}
                    variant="caption" color="text" fontWeight="medium">
                    <Tooltip title={t('delete')} className="paddingRight5"><Box className="ActionBlock"><DeleteIcon /></Box></Tooltip>
                  </MDTypography>
              }
            </span>
          };
          finalObj.push(tempObj);
        }
      }
    }
  }

  const rows = finalObj;

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={t('manageProduct')} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
      {(Object.keys(productData).length > 0) ?
        <MDBox pt={6} pb={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <MDBox mx={2} className="ManageProductTopSec" mt={0} py={4} px={2} pb={1} variant="gradient">
                  <Grid container className="FilterSectionBox ManageProductContainer" spacing={2} >
                    <Grid item xs={12} sm={2} md={2} className="filterGrid" >
                      <MDInput
                        select
                        name="statusFilter"
                        className="ManageProductTopSecip"
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        label={t('Status')}
                        value={productContext.statusFilter}
                        onChange={(obj) => {
                          setProductContext(dispatch, { ...productContext, statusFilter: obj.target.value });
                        }} fullWidth
                      >
                        <MenuItem value={'all'}>{t('all')}</MenuItem>
                        <MenuItem value={0}>{t('draft')}</MenuItem>
                        <MenuItem value={1}>{t('approved')}</MenuItem>
                        <MenuItem value={2}>{t('approvalPending')}</MenuItem>
                        <MenuItem value={3}>{t('rejected')}</MenuItem>
                        <MenuItem value={4}>{t('archived')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2} className="filterGrid">
                      <MDInput
                        select
                        name="searchBy"
                        label={t('searchBy')}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={productContext.searchBy}
                        onChange={(obj) => {
                          if (obj.target.value == 'none') {
                            setProductContext(dispatch, { ...productContext, searchValue: '', searchBy: obj.target.value });
                          }
                          else
                            setProductContext(dispatch, { ...productContext, searchBy: obj.target.value });
                        }}
                        fullWidth
                      >
                        <MenuItem value={'none'}>{t('none')}</MenuItem>
                        <MenuItem value={'id'}>{t('productId')}</MenuItem>
                        <MenuItem value={'title'}>{t('title')}</MenuItem>
                        <MenuItem value={'sku'}>{t('sku')}</MenuItem>
                        <MenuItem value={'barcode'}>{t('barcode')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2} className="filterGrid" >
                      <MDInput
                        type="text"
                        label={t('searchInput')}
                        name="searchValue"
                        disabled={(productContext.searchBy == 'none') ? true : false}
                        value={productContext.searchValue}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(obj) => {
                          setProductContext(dispatch, { ...productContext, searchValue: obj.target.value });
                        }}
                        fullWidth />
                    </Grid>
                    <Grid item xs={12} sm={2} md={2} className="filterGrid">
                      <MDInput
                        select
                        name="Sort By"
                        value={productContext.orderBy}
                        label={t('orderBy')}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(obj) => {
                          setProductContext(dispatch, { ...productContext, orderBy: obj.target.value });
                        }} fullWidth
                      >
                        <MenuItem value={'id'}>{t('id')}</MenuItem>
                        <MenuItem value={'title'}>{t('title')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2} className="filterGrid">
                      <MDInput
                        select
                        name="orderBy"
                        value={productContext.orderValue}
                        label={t('order')}
                        InputProps={{
                          classes: { root: "filterStyle" },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(obj) => {
                          setProductContext(dispatch, { ...productContext, orderValue: obj.target.value });
                        }}
                        fullWidth
                      >
                        <MenuItem value={'DESC'}>{t('DESC')}</MenuItem>
                        <MenuItem value={'ASC'}>{t('ASC')}</MenuItem>
                      </MDInput>
                    </Grid>
                    <Grid item xs={12} sm={1} md={1} className="filterGrid">
                      <FormControl className="filterSubmit">
                        <MDButton
                          onClick={() => {
                            navigate("/products/manage");
                            if (typeof pageNo === "undefined")
                              data();
                          }}
                          key="submit" type="submit" color="info" size="small" disableRipple fullWidth>{t('submit')}</MDButton>
                        {isProductContextChanged && (
                          <MDButton onClick={handleResetFilters} key="reset" type="submit" color="info" size="small" className="ResetButton" disableRipple fullWidth>{t('reset')}</MDButton>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                </MDBox>
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    showTotalEntries={true}
                    responseResultCount={responseResultCount}
                    paginationSize={MyContext.paginationSize}
                    paginationLink={"/products/manage/page-"}
                    pageSelected={pageSelected}
                  />
                  <DeleteConfirmation
                    confirmationDialogOpen={confirmationDialogOpen}
                    setConfirmationDialogOpen={setConfirmationDialogOpen}
                    deleteId={deleteId}
                    handleProductDelete={handleProductDelete}
                    dataFrom="product"
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>
        :
        null
      }
    </DashboardLayout>
  );
}


export default Manage;
